export const SET_USER = 'SET_USER';
export const SET_VESSEL = 'SET_VESSEL';
